// Shrink a phone photo in the browser before upload. A modern phone photo is
// 3–8 MB; 1600px on the long edge at q0.8 is plenty to see how a task should
// look, uploads quickly on café wifi, and stays well under upload limits.
// Same settings as the handoff report's photos.
const MAX_EDGE = 1600;
const JPEG_QUALITY = 0.8;

export async function downscaleImage(file) {
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close?.();
  return { base64: canvas.toDataURL('image/jpeg', JPEG_QUALITY), mime: 'image/jpeg' };
}
